module.exports = __webpack_public_path__ + "img/sredstva-izmerenij.f36b9f2e.svg";